import { useEffect, useState } from 'react'
import { useTheme, css } from '@fable/theme'

import { routes } from '../routes'
import { routes as storeRoutes } from '../../store/routes'

import { AuthForm } from '../components/auth_form/AuthForm'

import { FORM_TYPES } from '../constants'
import { FlexBox, PageContainer } from '@fable/components'
import { useLocation } from 'react-router-dom'

const AuthPage = ({ ...props }) => {
  const { mediaQueries } = useTheme()
  const {
    pathname,
    state,
  }: { pathname: string; state?: { from?: { pathname?: string } } } =
    useLocation()
  const [authType, setAuthType] = useState('')
  const { SIGN_IN, SIGN_UP } = FORM_TYPES
  const redirectUrl = state?.from?.pathname || storeRoutes.explore

  const styles = {
    wrapper: css`
      height: auto;
      ${mediaQueries.mobile} {
        height: calc(100vh - 60px);
      }
    `,
  }

  useEffect(() => {
    const path = pathname

    switch (path) {
      case routes.signIn:
        setAuthType(SIGN_IN)
        break
      case routes.signUp:
        setAuthType(SIGN_UP)
        break
      default:
        setAuthType(SIGN_UP)
    }
  }, [SIGN_IN, SIGN_UP, pathname])

  return (
    <PageContainer>
      <FlexBox centerAll className={styles.wrapper}>
        <AuthForm type={authType} path={redirectUrl} {...props} />
      </FlexBox>
    </PageContainer>
  )
}

export default AuthPage
